module.exports = __webpack_public_path__ + "static/media/spotlight-section-header-logo.85be85d9.jpg";